import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { ButtonSmall, Tooltip } from 'react-wot-bootstrap'

import styles from './ButtonInbox.scss'

class ButtonInbox extends React.PureComponent {
    static propTypes = {
        messages: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        onClick: PropTypes.func.isRequired,
        muteClick: PropTypes.bool,
        type: PropTypes.string,
    }

    static defaultProps = { type: 'mini' }

    render() {
        const messages = this.props.messages ? (
            <div className={styles.messages}>
                {this.props.messages > 99 ? '99+' : this.props.messages}
            </div>
        ) : null
        const buttonClassName = this.props.messages > 0 ? styles['base__new-message'] : ''

        return (
            <ButtonSmall
                type={this.props.type}
                onClick={this.props.onClick}
                muteClick={this.props.muteClick}
                tooltipId='invites-applications-tooltip'
                mixClassName={buttonClassName}
            >
                {messages}
                <div className={styles.icon} />
                <Tooltip id='invites-applications-tooltip'>
                    <FormattedMessage
                        id="invites_applications_tooltip"
                        defaultMessage="Нажмите, чтобы отобразить заявки и приглашения в ваш клан."
                    />
                </Tooltip>
            </ButtonSmall>
        )
    }
}

export default ButtonInbox



// WEBPACK FOOTER //
// ./components/ButtonInbox/ButtonInbox.jsx